import { RevenueReportDetailPage } from "@/features/revenue-report/pages/RevenueReportDetailPage";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/revenue-report/$id/detail")({
	validateSearch: (search: Record<string, unknown>): { tab?: string } => ({
		tab: typeof search.tab === "string" ? search.tab : undefined,
	}),
	beforeLoad({ context }) {
		if (
			!context.authAdapter.can({
				permissions: ["revenue_report.view"],
			})
		) {
			throw redirect({ to: "/403" });
		}
	},
	component: RevenueReportDetailPage,
});
